    function resizeRelatedArticleImages() {
        var related_article_component_height = jQuery('.related-articles').height();
        if (related_article_component_height > 0) {
            var article_image = jQuery('.related-articles__image'),
                smallest_article_image,
                article_container = jQuery(".related-articles__image-container");

            //find the first image with non 0 height
            jQuery(article_image).each(function () {
                if (jQuery(this).height() != 0) {
                    smallest_article_image = jQuery(this);
                    return false;
                }
            });
            //console.log(smallest_article_image);

            //find the smallest image height
            jQuery(article_image).each(function () {
                if (jQuery(this).height() < jQuery(smallest_article_image).height() && jQuery(this).height() !== 0) {
                    smallest_article_image = jQuery(this);
                }
            });

            //change image height to smallest image height
            var smallest_article_image_height = smallest_article_image.height();
            jQuery(article_container).each(function () {
                jQuery(this).height(smallest_article_image_height)
            });
        }
    }

  jQuery(window).on('resize load', function ()
          {
            resizeRelatedArticleImages();
          }
      );

  jQuery(".article-show-more").on('click', function ()
          {
            resizeRelatedArticleImages();
          }
      );